import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { HypothesisSnapshot } from '../../types/game';

interface HypothesisControlsProps {
  stack: HypothesisSnapshot[];
  onPush: (label: string) => void;
  onPop: () => void;
}

export function HypothesisControls({ stack, onPush, onPop }: HypothesisControlsProps) {
  const { t } = useTranslation('game');
  const [inputOpen, setInputOpen] = useState(false);
  const [label, setLabel] = useState('');

  function handlePush() {
    const l = label.trim() || `Гипотеза ${stack.length + 1}`;
    onPush(l);
    setLabel('');
    setInputOpen(false);
  }

  return (
    <div className="flex items-center gap-2 flex-wrap">
      {stack.length > 0 && (
        <div className="flex items-center gap-1.5 text-xs font-mono text-mafia-muted">
          <span>→</span>
          {stack.map((s, i) => (
            <span key={s.id} className="text-mafia-gold/70">
              {s.label}
              {i < stack.length - 1 && <span className="text-mafia-muted ml-1">›</span>}
            </span>
          ))}
        </div>
      )}

      {inputOpen ? (
        <div className="flex items-center gap-1.5">
          <input
            autoFocus
            type="text"
            value={label}
            onChange={(e) => setLabel(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handlePush()}
            placeholder={t('board.hypothesis.label')}
            className="text-xs font-mono bg-mafia-card border border-mafia-border text-mafia-paper px-2 py-1 rounded w-32 focus:border-mafia-gold/50 outline-none"
          />
          <button onClick={handlePush} className="text-xs font-mono text-mafia-gold hover:text-mafia-gold-light transition-colors">
            ✓
          </button>
          <button onClick={() => setInputOpen(false)} className="text-xs font-mono text-mafia-muted hover:text-mafia-paper-dim transition-colors">
            ✕
          </button>
        </div>
      ) : (
        <button
          onClick={() => setInputOpen(true)}
          className="text-[10px] font-mono uppercase tracking-wider text-mafia-muted hover:text-mafia-gold transition-colors border border-mafia-border/50 px-2 py-1 rounded"
        >
          {t('board.hypothesis.create')}
        </button>
      )}

      {stack.length > 0 && (
        <button
          onClick={onPop}
          className="text-[10px] font-mono uppercase tracking-wider text-mafia-crimson/70 hover:text-mafia-crimson transition-colors border border-mafia-crimson/30 px-2 py-1 rounded"
        >
          {t('board.hypothesis.restore')}
        </button>
      )}
    </div>
  );
}
